import { apiFetch } from './client';

export interface UserProfile {
  id: string;
  keycloakSub: string;
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  phone?: string;
  countryCode?: string;
  avatarUrl?: string;
  mfaEmail?: string;
  mfaVerified: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateProfilePayload {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  countryCode?: string;
  avatarUrl?: string;
}

export interface UserRole {
  id: string;
  userId: string;
  role: string;
  assignedBy: string;
  assignedAt: string;
}

export const getCurrentUser = async (): Promise<UserProfile> => {
  return apiFetch<UserProfile>('/users/me');
};

export const updateProfile = async (
  data: UpdateProfilePayload,
): Promise<UserProfile> => {
  return apiFetch<UserProfile>('/users/me', {
    method: 'PUT',
    data,
  });
};

export const updateMfaEmail = async (
  mfaEmail: string,
): Promise<UserProfile> => {
  return apiFetch<UserProfile>('/users/me/mfa', {
    method: 'PUT',
    data: { mfaEmail },
  });
};

export const verifyMfa = async (): Promise<UserProfile> => {
  return apiFetch<UserProfile>('/users/me/mfa/verify', {
    method: 'POST',
  });
};

export const getUserRoles = async (): Promise<{ roles: UserRole[] }> => {
  return apiFetch<{ roles: UserRole[] }>('/users/me/roles');
};
